<template>
  <div class="lby-news-carousel">
    <el-carousel height="50px" :autoplay="true" indicator-position="none">
      <el-carousel-item v-for="item in data" :key="item.id">
        <h3 @click="goToPage(item.id)">{{ item.news }}</h3>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { getTop5GoodsList } from '@/api/goods/index'
import { getTop5GameLogList } from '@/api/gamelogs/index'
export default {
  name: 'NewsCarousel',
  props: {
    type: {
      type: String
    }
  },
  data () {
    return {
      data: ''
    }
  },
  methods: {
    goToPage (id) {
      if (id === 'ads') {
        return
      }
      if (this.type === 'goodsinfo') {
        this.$router.push({
          path: '/goodsinfo',
          query: {
            goodsId: id
          }
        })
      } else if (this.type === 'lotterycenter') {
        if (this.$route.path === '/lotterycenter') {
          return
        }
        this.$router.push({
          path: '/lotterycenter'
        })
      }
    },
    async getData () {
      if (this.type === 'goodsinfo') {
        const res = await getTop5GoodsList()
        this.data = res.data.list.map(item => {
          return {
            id: item.id,
            news: '热门账号' + (item.fightNumber ? item.fightNumber + '战' : '') + (item.price ? '，仅需' + item.price + '元' : '')
          }
        })
      } else if (this.type === 'lotterycenter') {
        const res = await getTop5GameLogList()
        this.data = res.data.list.map(item => {
          return {
            id: item.id,
            news: '恭喜“' + (item.userName ? item.userName : '') + (item.gameName ? '”在[' + item.gameName + ']游戏' : '') + (item.gap ? '喜中' + item.gap + '倍积分' : '')
          }
        })
      } else {
        this.data = [{ id: 'ads', news: '广告位招租中，可定制广告页面' }]
      }
    }
  },
  created () {
    this.getData()
  }
}
</script>

<style scoped lang="less">
.lby-news-carousel{
    width: 540px;
    line-height: 50px;
    border: solid white 4px;
    border-radius: 1px;
    color: white;
    h3:hover{
      cursor: pointer;
    }
}
</style>
